import { ChangeDetectionStrategy, Component, inject, Input, HostListener } from '@angular/core';
import { PIconModule } from '@panaya/ui/p-icon';
import { AiChatUiEventsService } from '../../../ai-chat-ui-events.service';
import { SUGGESTION_ICON_MAP } from '../../../injection-tokens';

@Component({
    standalone: true,
    selector: 'ai-chat-suggestion',
    imports: [PIconModule],
    templateUrl: './ai-chat-suggestion.component.html',
    styleUrls: ['./ai-chat-suggestion.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AiChatSuggestionComponent {
    @Input() public label = '';
    @Input() public type = '';

    private readonly uiEvents = inject(AiChatUiEventsService);
    private readonly iconMap = inject(SUGGESTION_ICON_MAP);

    get iconName(): string {
        return this.iconMap[this.type] ?? 'message-square';
    }

    @HostListener('click', ['$event'])
    protected triggerSuggestionPrompt(): void {
        this.uiEvents.suggestionRequest.emit(this.label);
    }
}
